const solve_US_Locale = {
    'solve.swiperCenter1': 'Comprehensive Supplier of Intelligent Medical Ultrasound Imaging Solutions',
    'solve.swiperCenter2': 'NiCE: Ultrasound Imaging AI Deployment Platform',
    'solve.swiperName': 'Solutions',
    'solve.title1': 'Full-Stack Intelligent Ultrasound Solutions',
    'solve.title2': 'NiCE: AI Ultrasound Deployment Platform',
}
export default solve_US_Locale
